module.exports = __webpack_public_path__ + "img/mm.12ba82ed.png";